import axios from 'axios';
import { BASE_URL } from '../config/config';

// const URL = 'http://localhost:3000/internals';
const URL = BASE_URL + '/internals';

const getInternalList = async (keyword, page, limit) => {
  try {
    const response = await axios.get(URL, {
      params: {
        keyword,
        page,
        limit,
      },
    });
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

const createInternal = async (data) => {
  try {
    const result = await axios.post(URL, data);
    console.log(result);
  } catch (error) {
    if (error.response && error.response.data && error.response.data.message) {
      throw new Error(error.response.data.message); // Lempar kesalahan jika ada
    } else {
      throw new Error('There was an error creating the internal.');
    }
  }
};

const updateInternal = async (id, data) => {
  try {
    await axios.put(`${URL}/${id}`, data);
  } catch (error) {
    if (error.response && error.response.data && error.response.data.message) {
      throw new Error(error.response.data.message); // Lempar kesalahan jika ada
    } else {
      throw new Error('There was an error updating the internal.');
    }
  }
};

const deleteInternal = async (id) => {
  try {
    await axios.delete(`${URL}/${id}`);
  } catch (error) {
    console.log(error);
  }
};

const getInternalById = async (id) => {
  try {
    const result = await axios.get(`${URL}/${id}`);
    return result.data;
  } catch (error) {
    console.log(error);
  }
};

export {
  getInternalList,
  createInternal,
  updateInternal,
  deleteInternal,
  getInternalById,
};
